import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseRequester } from './common/base-requester';
import { Moment } from 'moment';

@Injectable({
    providedIn: 'root',
})
export class AbcAnalysisService extends BaseRequester {
    constructor() {
        super();
    }

    get(afterDate: Moment): Observable<AbcAnalysisResponse[]> {
        return this.internalPostRequest<AbcAnalysisRequest>(
            environment.abcAnalysisEndpoint,
            {
                after_iso_date: afterDate.toISOString(),
            },
        ).pipe(
            map((response) =>
                this.serviceHandler<AbcAnalysisResponse[]>(response),
            ),
        );
    }
}

interface AbcAnalysisRequest {
    after_iso_date: string;
}

export interface AbcAnalysisResponse {
    // 'N' = new product (created within the last 6 months, too new to rank);
    // reported regardless of sales. See temp/abc-README.md.
    class: 'A' | 'B' | 'C' | 'D' | 'N';
    pid: number;
    // null when the pid sold but is no longer in the product catalog.
    sku: string | null;
    title: string | null;
    total_sale: number;
    // Fraction of total window revenue (0-1), rounded to 6 decimals.
    sale_share: number;
}
